export default {
  menuPages: [],
  currentPage: null,
  loading: false,
  error: null
}
